// S1 Phase 7 (R2 #6) — D-Day 표시 헬퍼.
//
// 계약 만료까지 남은 일수(daysRemaining)를 부호와 함께 표시한다.
//   - 미래 (양수 / 0): `D-N` (예: 30 → 'D-30', 0 → 'D-0')
//   - 과거 (음수):     `D+N` (예: -815 → 'D+815')  ← 만료 후 경과 일수
//   - 알 수 없음(null): `D-?`
//
// 기존 버그: 음수일 때 `D-${-815}` = 'D--815' 로 렌더되던 것을 수정.
export function formatDDay(daysRemaining: number | null | undefined): string {
  return formatDdayOrNull(daysRemaining) ?? 'D-?';
}

/**
 * 다계약 표시 차수3 정정2(26-08-06) — 같은 D-Day 글자, **값이 없을 때만 다른 답**.
 *
 * 위 formatDDay 는 모르는 값을 'D-?' 라고 적는다(그 자리에 무언가는 있어야 하는 화면).
 * 이 함수는 null 을 돌려준다 — '–' 로 적을지, 아무것도 적지 않을지, 다른 말을 적을지를
 * **부르는 자리**가 정하는 화면(고객사 마스터 시트의 D-Day 칸 · 계약 표기 정본
 * lib/term-basis 의 반납일 조각)이 이것을 쓴다. 종전엔 시트가 이 함수를 자기 안에 들고
 * 있어서 부호 규칙이 두 벌이었다 — 정본을 이 파일 하나로 모은다.
 */
export function formatDdayOrNull(daysRemaining: number | null | undefined): string | null {
  if (daysRemaining == null) return null;
  return daysRemaining < 0 ? `D+${Math.abs(daysRemaining)}` : `D-${daysRemaining}`;
}
